import { gql } from '@apollo/client';

export const EMAIL_REPORT_SETTINGS_FIELDS = `
  dailyRecapEnabled
  weeklyRecapEnabled
  monthlyRecapEnabled
  advancedSource
  kpiSectionId
  customReportId
  includeInventoryRestock
  recipientEmails
  entitlements {
    dailyAllowed
    weeklyAllowed
    monthlyAllowed
    weeklyOncePerMonth
    advancedSourcesAllowed
    inventoryRestockAllowed
  }
`;

export const GET_EMAIL_REPORT_SETTINGS = gql`
  query GetEmailReportSettings {
    getEmailReportSettings {
      ${EMAIL_REPORT_SETTINGS_FIELDS}
    }
  }
`;

export const UPDATE_EMAIL_REPORT_SETTINGS = gql`
  mutation UpdateEmailReportSettings($settings: UpdateEmailReportSettingsInput!) {
    updateEmailReportSettings(settings: $settings) {
      ${EMAIL_REPORT_SETTINGS_FIELDS}
    }
  }
`;

export const SEND_TEST_EMAIL_RECAP = gql`
  mutation SendTestEmailRecap(
    $settings: UpdateEmailReportSettingsInput
    $recapType: String
  ) {
    sendTestEmailRecap(settings: $settings, recapType: $recapType) {
      ok
      recapType
      recipients
      subject
      warnings
    }
  }
`;
